import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import classNames from 'classnames';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import { SENTIMENTS, TRANSLATION_KEY, VERDICT_OUTCOMES } from '../constants';
import { verdictShape } from '../propShapes';
import css from './VerdictBadge.css';

const FAILED_BADGE = 'failed';

const BADGES = {
    [SENTIMENTS.HEADS_UP]: { icon: 'trending-down', className: 'headsUp' },
    [SENTIMENTS.GOOD_NEWS]: { icon: 'trending-up', className: 'goodNews' },
    [SENTIMENTS.NEUTRAL]: { icon: 'minus', className: 'neutral' },
    [VERDICT_OUTCOMES.PROMPT_UNCLEAR]: { icon: 'point-filled', className: 'needsReply' },
    [VERDICT_OUTCOMES.NO_VERDICT]: { icon: 'minus', className: 'noVerdict' },
    [FAILED_BADGE]: { icon: 'alert-triangle', className: 'failed' },
};

const getBadgeState = verdict => {
    if (!verdict) return null;
    if (verdict.outcome === VERDICT_OUTCOMES.NO_VERDICT) return VERDICT_OUTCOMES.NO_VERDICT;
    if (verdict.outcome === VERDICT_OUTCOMES.ERROR) return FAILED_BADGE;
    if (verdict.outcome === VERDICT_OUTCOMES.PROMPT_UNCLEAR) return VERDICT_OUTCOMES.PROMPT_UNCLEAR;
    return BADGES[verdict.sentiment] ? verdict.sentiment : SENTIMENTS.NEUTRAL;
};

const VerdictBadge = ({ verdict = null, compact = false }) => {
    const state = getBadgeState(verdict);
    if (!state) return null;
    const { icon, className } = BADGES[state];
    return (
        <span className={classNames(css.badge, css[className], { [css.compact]: compact })}>
            <Icon name={icon} size={IconSizes.XX_SMALL} className={css.badgeIcon} interactive={false} />
            <Translate id={`${TRANSLATION_KEY}.BADGES.${state.toUpperCase()}`} />
        </span>
    );
};

VerdictBadge.propTypes = {
    verdict: verdictShape,
    compact: PropTypes.bool,
};

export default VerdictBadge;
